// test681
(681 && 0);
